export enum ThresholdsType {
  COMPANY = 'company',
  USER = 'user',
}
